<template>
  <div class="page">
    <home-header activeIndex="4" pageTitle="校园Q&A" />
    <div class="wrap">
      <div class="list">
        <div
          class="item"
          v-for="(item, idx) in qaList"
          :key="idx"
          @click="toDetail(item)"
        >
          <img class="icon" :src="require('@/assets/qa.png')" alt="" />
          <div class="con">
            <div class="tit">{{ item.qaQuestions }}</div>
            <div class="desc">{{ item.qaAnswers }}</div>
          </div>
        </div>
      </div>
      <div class="pagination">
        <a-pagination
          v-model="page"
          @change="onChangePage"
          :total="total"
          :page-size="size"
          show-less-items
        />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import moment from "moment";
import { getQAList } from "@/api/notice";
import HomeHeader from "@/components/HomeHeader";
import Footer from "@/components/footer";

export default {
  name: "Home",
  components: {
    HomeHeader,
    Footer,
  },
  data() {
    return {
      page: 1,
      size: 5,
      total: 0,
      qaList: [],
    };
  },
  filters: {
    dateFilter(val) {
      return moment(+val).format("YYYY-MM-DD");
    },
  },
  methods: {
    toDetail(item) {
      this.$router.push({
        path: "/qaDetail",
        query: {
          item: item,
        },
      });
    },
    onChangePage(e) {
      this.getQA(e);
    },
    getQA(page) {
      getQAList({
        uvCode: localStorage.getItem("uvCode"),
        page: page,
        size: this.size,
      }).then((res) => {
        this.total = res.total;
        this.qaList = res.rows;
      });
    },
  },
  mounted() {
    this.getQA(this.page);
  },
};
</script>

<style lang="less" scoped>
.wrap {
  width: 1200px;
  background-color: #ffffff;
  border-radius: 4px;
  margin: 20px auto;
}
.list {
  min-height: 380px;
  .item {
    display: flex;
    align-items: center;
    padding: 0 32px;
    &:hover {
      background: #e8f3ff;
      cursor: pointer;
      .con {
        .tit {
          color: #2a79ff;
        }
      }
    }
    .icon {
      width: 32px;
      height: 32px;
      margin-right: 16px;
    }
    .con {
      border-bottom: solid 1px #dedede;
      padding: 18px 0;
      width: calc(100% - 48px);
      .tit {
        font-size: 16px;
        font-weight: 600;
        color: #333;
      }
      .desc {
        color: #999;
        font-size: 14px;
        padding-top: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
.pagination {
  text-align: center;
  padding: 24px 0 32px;
  /deep/ .ant-pagination-item-active {
    background: #2a79ff;
    a {
      color: #fff;
    }
  }
}
</style>
